
const types = {
    VISITED_QUESTIONS_SET_VISITED: 'VISITED_QUESTIONS_SET_VISITED',
};

const visitedQuestionsActions = {
    types,

    setVisited(contentRevisionId) {
        return { type: types.VISITED_QUESTIONS_SET_VISITED, contentRevisionId };
    },
};

export default visitedQuestionsActions;
